module.exports = __webpack_public_path__ + "043482d2b929cde94d1a2ee10dc3530a.woff2";